import { AWCButton, BUTTON_TYPES } from '../GlobalComponents/Inputs/Inputs'
import {
    fqAlert,
    fqConfirm,
    fqConfirmAllowNo,
} from '../GlobalComponents/NotificationManager/NotificationManager'

export const SuccessNotficationStory = () => {
    return (
        <AWCButton
            type={BUTTON_TYPES.SECONDARY}
            onClick={() => {
                fqAlert({
                    type: 'success',
                    message: 'Success!',
                })
            }}
            style={{ marginTop: 30, width: 100 }}
        >
            Success
        </AWCButton>
    )
}

export const WarningNotificationStory = () => {
    return (
        <AWCButton
            type={BUTTON_TYPES.SECONDARY}
            onClick={() => {
                fqAlert({ type: 'warning', message: 'This is a warning' })
            }}
            style={{ marginTop: 30, width: 100 }}
        >
            Warning
        </AWCButton>
    )
}

export const ErrorNotificationStory = () => {
    return (
        <AWCButton
            type={BUTTON_TYPES.SECONDARY}
            onClick={() => {
                fqAlert({
                    type: 'error',
                    title: 'Error!',
                    message: 'This is a test',
                })
            }}
            style={{ marginTop: 30, width: 100 }}
        >
            Error
        </AWCButton>
    )
}

export const ConfirmNotificationStory = () => {
    return (
        <AWCButton
            type={BUTTON_TYPES.SECONDARY}
            onClick={async () => {
                await fqConfirm({
                    title: 'Confirm',
                    message: 'This is a test',
                })
            }}
            style={{ marginTop: 30, width: 100 }}
        >
            Confirm
        </AWCButton>
    )
}

export const UnsavedNotificationStory = () => {
    return (
        <>
            <AWCButton
                type={BUTTON_TYPES.SECONDARY}
                onClick={async () => {
                    await fqConfirmAllowNo({
                        title: 'Unsaved changes',
                        message: 'Would you like to save before leaving?',
                    })
                }}
                style={{ marginTop: 30, width: 150 }}
            >
                Unsaved changes
            </AWCButton>
        </>
    )
}
